import { userConstants } from '../_constants';
import { userService } from '../_services';
import { history } from '../_helpers';
import { alertActions } from './';

export const userActions = {
  signin,
  signup,
  validateUser,
  passwordRecovery
}

function signin(data) {
  let username = data.user.username;

  return dispatch => {
    dispatch(request({username}));

    return userService.signin(data)
      .then(
        data => {
          history.push('/');
          return dispatch(success(data));
        },
        error => {
          return dispatch(failure(error));
        }
      )

    function request(data) {
      return { type: userConstants.SIGNIN_REQUEST, data }
    }

    function success(data) {
      return { type: userConstants.SIGNIN_SUCCESS, data }
    }

    function failure(error) {
      return { type: userConstants.SIGNIN_FAILURE, error }
    }
  }
}

function signup(data) {
  let email = data.user.email;

  return dispatch => {
    dispatch(request({email}));

    return userService.signup(data)
      .then(
        data => {
          return dispatch(success(data));
        },
        error => {
          return dispatch(failure(error));
        }
      )

    function request(data) {
      return { type: userConstants.SIGNIN_REQUEST, data }
    }

    function success(data) {
      return { type: userConstants.SIGNIN_SUCCESS, data }
    }

    function failure(error) {
      return { type: userConstants.SIGNIN_FAILURE, error }
    }
  }
}

function validateUser(data) {
  return dispatch => {
    dispatch(request(data));

    return userService.validateUser(data)
      .then(data => {
        return dispatch(success(data));
      }, error => {
        return dispatch(failure(error));
      })
  }

  function request(data) {
    return { type: userConstants.USER_VALIDATE_REQUEST, data }
  }

  function success(data) {
    return { type: userConstants.USER_VALIDATE_SUCCESS, data }
  }

  function failure(error) {
    return { type: userConstants.USER_VALIDATE_FAILURE, error }
  }
}

function passwordRecovery(data) {
  let email = data.user.email;

  return dispatch => {
    dispatch(request({email}));

    userService.passwordRecovery(data)
      .then(data => {
        dispatch(success(data));
        history.push('/recovery/success');
      })
      .then(error => {
        dispatch(failure(error));
        dispatch(alertActions.failure(error));
      })
  }

  function request(data) {
    return { type: userConstants.PASSWORD_RECOVERY_REQUEST, data }
  }

  function success(data) {
    return { type: userConstants.PASSWORD_RECOVERY_SUCCESS, data }
  }

  function failure(error) {
    return { type: userConstants.PASSWORD_RECOVERY_FAILURE, error }
  }
}